import DateFnsUtils from '@date-io/date-fns';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import { createTheme , MuiThemeProvider } from "@material-ui/core";
import React from "react";

export default function LSDatePicker2(props) {

    const {
        className,
        disableFuture,
        shouldDisableDate,
        views,
        format,
        placeholder,
        variant,
        minDate,
        value,
        onChange,
        disabled,
        invalidDateMessage,
        KeyboardButtonProps,
        InputProps
    } = props

    const customTheme = createTheme ({
        palette: {
            primary: {
                main: "#7367f0",
                dark: "#7367f0",
            },
        },
    });

    return(
        <MuiThemeProvider theme={customTheme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    className={className}
                    disabled={disabled}
                    disableFuture={disableFuture}
					shouldDisableDate={shouldDisableDate}
                    id="LSDatePicker2"
                    autoOk={true}
                    views={views}
                    format={format}
                    placeholder={placeholder}
                    variant={variant}
                    minDate={minDate}
                    value={value}
                    onChange={onChange}
                    KeyboardButtonProps={KeyboardButtonProps}
                    InputProps={InputProps}
					
                />
            </MuiPickersUtilsProvider>
        </MuiThemeProvider>
    )
}